const sumNumbers = (list, attr) => {
  const numbers = list.map((listItem) => Number(listItem[attr]));

  return numbers.reduce((a, b) => a + b, 0);
};

export { sumNumbers };
